const recurringInput = {
  frequency: {
    title: 'Set how this shift repeats over time',
    values: {
      dontRepeat: 'Does not repeat',
      day: 'Daily',
      week: 'Weekly',
      month: 'Monthly',
    },
    labels: {
      day: 'day(s)',
      week: 'week(s)',
      month: 'month(s)',
    },
  },
  repeatEvery: 'Repeat Every',
  repeatOn: 'Repeat On',
  repeatOnNote: 'Please select at least one day',
  ends: 'Ends',
  endsOn: 'Ends On',
  endsLabels: {
    never: 'Never ends',
    date: `Until {{date}}`,
    times: 'After {{number}} occurrences',
  },
  windowNote: 'Only the first {{count}} shifts are created now. The rest are generated automatically by a background process over time.',
  endsDateNote: 'The selected end date is too early - no shifts would be created. Choose a later date.',

  form: {
    month: 'Month',
    day: 'Day',
    week: 'Week',
    year: 'Year',
    occurrences: 'Occurrences',
    after: 'After',
    never: 'Never',
    on: 'On',
  },
};

export default recurringInput;
